/**
 * P6-3 倒计时 / 时间距离 chip
 *
 * 给客户详情、健康度告警等页面统一展示：
 *   - 加微时间 N 天前
 *   - 下次跟进截止还剩 X 小时 / 已逾期 X 小时
 *
 * 颜色分级（剩余小时数）：
 *   >24h  绿  ok
 *   12-24h 黄  warning
 *   <12h  橙  urgent
 *   <0    红  overdue
 */
import dayjs from 'dayjs';
import { fmtDate } from '../lib/format';
import { Pill } from './ui';

export function DaysSinceChip({ date, label = '加微' }: { date?: string | Date | null; label?: string }) {
  if (!date) return <span style={{ color: 'var(--text-3)' }}>—</span>;
  const d = dayjs(date);
  const days = dayjs().diff(d, 'day');
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12 }}>
      <span style={{ color: 'var(--text-2)' }}>📅 {label}：</span>
      <strong style={{ color: 'var(--text-1)' }}>{fmtDate(date)}</strong>
      <span style={{ color: 'var(--text-3)' }}>（{days === 0 ? '今天' : `${days} 天前`}）</span>
    </span>
  );
}

export function CountdownChip({
  dueAt,
  label = '下次跟进',
}: {
  dueAt?: string | Date | null;
  label?: string;
}) {
  if (!dueAt) return null;
  const due = dayjs(dueAt);
  const hours = due.diff(dayjs(), 'hour');
  const overdue = hours < 0;
  const tone: any = overdue ? 'danger'
                  : hours < 12 ? 'warning'
                  : hours < 24 ? 'warning'
                  : 'success';
  const text = overdue
    ? `已逾期 ${Math.abs(hours)} 小时`
    : hours < 24
      ? `还剩 ${hours} 小时`
      : `还剩 ${Math.floor(hours / 24)} 天 ${hours % 24} 小时`;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12 }}>
      <span style={{ color: 'var(--text-2)' }}>⏰ {label}：</span>
      <Pill tone={tone}>{text}</Pill>
    </span>
  );
}

/** 公海倒计时（用 customer.pool_force_due_at 或类似计算） */
export function PoolCountdownChip({ leaveAt }: { leaveAt?: string | Date | null }) {
  if (!leaveAt) return null;
  const days = dayjs(leaveAt).diff(dayjs(), 'day');
  if (days < 0) return <Pill tone="danger">已进公海</Pill>;
  const tone: any = days < 1 ? 'danger' : days < 3 ? 'warning' : 'default';
  return <Pill tone={tone}>距进公海 {days} 天</Pill>;
}
